import React, { useEffect, useState } from 'react'
import { Box, Divider, Stack, Typography } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import { useBreakpoints } from '../../../../../components/breakpoints/BreakpointsProvider'
import InfoField from '../../../../../components/InfoField'
import { maskEmail } from '../../../../../utils/authentUtils'
import ButtonDefault from '../../../../../components/ButtonDefault'
import appConst from '../../../../../constant/appConstants'
import { connect } from 'react-redux'
import { cardiboxActions, cardiboxSelectors } from 'redux-cardibox'
import { getConjoint } from '../../../../webservices/affiliation/affiliationSelector'
import ConfirmCancelInvitePopin from './ConfirmCancelInvitePopin'
import ConfirmResendInvitePopin from './ConfirmResendInvitePopin'
import ConfirmRevokeConjointAccessPopin from './ConfirmRevokeConjointAccessPopin'
import CreateConjointAccessPopin from './CreateConjointAccessPopin'

const ARTICLE_SHORTCUT_NO_ACCESS = 'partage_acces_intro_acces_inexistant'
const ARTICLE_SHORTCUT_INVITATION_SEND = 'partage_acces_intro_acces_envoye'
const ARTICLE_SHORTCUT_ACCESS_GRANTED = 'partage_acces_intro_acces_actif'
const ARTICLE_SHORTCUT_ACCESS_REVOKED = 'partage_acces_intro_acces_revoque'


const PartageConnexion = (
	{
		// @ts-ignore
		userConjointAccess,
		// @ts-ignore
		setUserConjointAccess,
		// @ts-ignore
		getArticleByShortcut,
		// @ts-ignore
		articleNoAccess,
		// @ts-ignore
		articleSend,
		// @ts-ignore
		articleGranted,
		// @ts-ignore
		articleRevoked,
	    // @ts-ignore
		conjoint
	}
) => {
	const intl = useIntl()
	const { isMobile, isDesktop, isLaptop, isTabletPortrait, isWidescreen } = useBreakpoints()
	const [articleIntro, setArticleIntro] = useState<any>(undefined)
	const [openCreateAccess, setOpenCreateAccess] = useState<boolean>(false)
	const [openRevokeAccess, setOpenRevokeAccess] = useState<boolean>(false)
	const [openCancelInvitAccess, setOpenCancelInvitAccess] = useState<boolean>(false)
	const [openResendAccess, setOpenResendAccess] = useState<boolean>(false)

	useEffect(() => {
		if(userConjointAccess){
			if(userConjointAccess.statutInvitation === "ACCESS_GRANTED"){
				getArticleByShortcut(appConst.cardiboxApi, ARTICLE_SHORTCUT_ACCESS_GRANTED)
			} else if(userConjointAccess.statutInvitation === "INVITATION_SEND"){
				getArticleByShortcut(appConst.cardiboxApi, ARTICLE_SHORTCUT_INVITATION_SEND)
			} else if(userConjointAccess.statutInvitation === "ACCESS_REVOKED"){
				getArticleByShortcut(appConst.cardiboxApi, ARTICLE_SHORTCUT_ACCESS_REVOKED)
			}
			getArticleByShortcut(appConst.cardiboxApi, ARTICLE_SHORTCUT_NO_ACCESS)
		}
	}, [userConjointAccess])

	const renderAccess = () => {
		if (userConjointAccess && conjoint && conjoint[0].toString() === userConjointAccess.idAdherent) {
			switch (userConjointAccess.statutInvitation) {
				case "INVITATION_SEND":
					return (
						<>
							<Stack direction={isMobile ? 'column' : 'row'} spacing="14px" alignItems="center">
								<Typography variant="body2">
									{(articleSend && articleSend.fields) && <div dangerouslySetInnerHTML={{ __html: articleSend.fields.body }} />}
								</Typography>
							</Stack>
							<Stack width="100%" direction={isMobile ? 'column' : 'row'} spacing="16px" justifyContent="space-between">
								<Stack width="100%" direction="column" spacing="16px" justifyContent="space-between">
									<InfoField
										label={intl.formatMessage({ id: 'personalInfo.partageConnexion.labels.prenom_nom' })}
										value={conjoint[1].prenom + ' ' +  conjoint[1].nom || ''}
										variantValue="body1"
									/>
									<InfoField
										label={intl.formatMessage({ id: 'personalInfo.partageConnexion.labels.statut' })}
										value={intl.formatMessage({ id: 'personalInfo.partageConnexion.statut.'+userConjointAccess.statutInvitation })}
										variantValue="body1"
										sx={{ color: '#e96e11' }}
									/>
								</Stack>
								<Stack width="100%" direction="column" spacing="16px" justifyContent="space-between" alignSelf="flex-start">
									<InfoField
										label={intl.formatMessage({ id: 'personalInfo.partageConnexion.labels.email' })}
										value={maskEmail(userConjointAccess.email) || ''}
										variantValue="body1"
									/>
									<InfoField
										label={intl.formatMessage({ id: 'personalInfo.partageConnexion.labels.date_envoie' })}
										value={new Date(userConjointAccess.dateInvitation).toLocaleDateString('fr-FR') || ''}
										variantValue="body1"
									/>
								</Stack>
							</Stack>
							<Box display="flex" justifyContent="center">
								<Stack direction={isMobile ? 'column' : 'row'} spacing="12px">
									<ButtonDefault variant="outlined" onClick={() => setOpenCancelInvitAccess(true)}>
										<FormattedMessage id="personalInfo.partageConnexion.buttons.cancelInvit" />
									</ButtonDefault>
									<ButtonDefault variant="contained" onClick={() => setOpenResendAccess(true)}>
										<FormattedMessage id="personalInfo.partageConnexion.buttons.reSend" />
									</ButtonDefault>
								</Stack>
							</Box>
						</>
					)
				case "ACCESS_GRANTED":
					return (
						<>
							<Stack direction={isMobile ? 'column' : 'row'} spacing="14px" alignItems="center">
								<Typography variant="body2">
									{(articleGranted && articleGranted.fields) && <div dangerouslySetInnerHTML={{ __html: articleGranted.fields.body }} />}
								</Typography>
							</Stack>
							<Stack width="100%" direction={isMobile ? 'column' : 'row'} spacing="16px" justifyContent="space-between">
								<Stack width="100%" direction="column" spacing="16px" justifyContent="space-between">
									<InfoField
										label={intl.formatMessage({ id: 'personalInfo.partageConnexion.labels.prenom_nom' })}
										value={conjoint[1].prenom + ' ' +  conjoint[1].nom || ''}
										variantValue="body1"
									/>
									<InfoField
										label={intl.formatMessage({ id: 'personalInfo.partageConnexion.labels.statut' })}
										value={intl.formatMessage({ id: 'personalInfo.partageConnexion.statut.'+userConjointAccess.statutInvitation })}
										variantValue="body1"
										sx={{ color: '#8AC11D' }}
									/>
								</Stack>
								<Stack width="100%" direction="column" spacing="16px" justifyContent="space-between" alignSelf="flex-start">
									<InfoField
										label={intl.formatMessage({ id: 'personalInfo.partageConnexion.labels.email' })}
										value={maskEmail(userConjointAccess.email) || ''}
										variantValue="body1"
									/>
									<InfoField
										label={intl.formatMessage({ id: 'personalInfo.partageConnexion.labels.date_activation' })}
										value={new Date(userConjointAccess.dateAcceptation).toLocaleDateString('fr-FR') || ''}
										variantValue="body1"
									/>

								</Stack>
							</Stack>
							<Box display="flex" justifyContent="center">
								<ButtonDefault  variant="contained" onClick={() => setOpenRevokeAccess(true)}>
									<FormattedMessage id="personalInfo.partageConnexion.buttons.revokeAccess" />
								</ButtonDefault>
							</Box>
						</>
					)
				case "ACCESS_REVOKED":
					return (
						<>
							<Stack direction={isMobile ? 'column' : 'row'} spacing="14px" alignItems="center">
								<Typography variant="body2">
									{(articleRevoked && articleRevoked.fields) && <div dangerouslySetInnerHTML={{ __html: articleRevoked.fields.body }} />}
								</Typography>
							</Stack>
							<Stack width="100%" direction={isMobile ? 'column' : 'row'} spacing="16px" justifyContent="space-between">
								<Stack width="100%" direction="column" spacing="16px" justifyContent="space-between">
									<InfoField
										label={intl.formatMessage({ id: 'personalInfo.partageConnexion.labels.prenom_nom' })}
										value={conjoint[1].prenom + ' ' +  conjoint[1].nom || ''}
										variantValue="body1"
									/>
									<InfoField
										label={intl.formatMessage({ id: 'personalInfo.partageConnexion.labels.statut' })}
										value={intl.formatMessage({ id: 'personalInfo.partageConnexion.statut.'+userConjointAccess.statutInvitation })}
										variantValue="body1"
										sx={{ color: '#FC454A' }}
									/>
								</Stack>
								<Stack width="100%" direction="column" spacing="16px" justifyContent="space-between" alignSelf="flex-start">
									<InfoField
										label={intl.formatMessage({ id: 'personalInfo.partageConnexion.labels.email' })}
										value={maskEmail(userConjointAccess.email) || ''}
										variantValue="body1"
									/>
									<InfoField
										label={intl.formatMessage({ id: 'personalInfo.partageConnexion.labels.date_revocation' })}
										value={new Date(userConjointAccess.dateRevocation).toLocaleDateString('fr-FR') || ''}
										variantValue="body1"
									/>
								</Stack>
							</Stack>
							<Box display="flex" justifyContent="center">
								<ButtonDefault variant="contained"  onClick={() => setOpenCreateAccess(true)}>
									<FormattedMessage id="personalInfo.partageConnexion.buttons.grantAccess" />
								</ButtonDefault>
							</Box>
						</>
					)
				default:
					return (
					<>
						<Stack direction={isMobile ? 'column' : 'row'} spacing="14px" alignItems="center">
							<Typography variant="body2">
								{(articleNoAccess && articleNoAccess.fields) && <div dangerouslySetInnerHTML={{ __html: articleNoAccess.fields.body }} />}
							</Typography>
						</Stack>
						<Box display="flex" justifyContent="center">
							<ButtonDefault variant="contained"  onClick={() => setOpenCreateAccess(true)}>
								<FormattedMessage id="personalInfo.partageConnexion.buttons.grantAccess" />
							</ButtonDefault>
						</Box>
					</>)
			}
		}
		return (<>
			<Stack direction={isMobile ? 'column' : 'row'} spacing="14px" alignItems="center">
				<Typography variant="body2">
					{(articleNoAccess && articleNoAccess.fields) && <div dangerouslySetInnerHTML={{ __html: articleNoAccess.fields.body }} />}
				</Typography>
			</Stack>
			<Box display="flex" justifyContent="center">
				<ButtonDefault variant="contained"  onClick={() => setOpenCreateAccess(true)}>
					<FormattedMessage id="personalInfo.partageConnexion.buttons.grantAccess" />
				</ButtonDefault>
			</Box>
		</>)
	}

	return (
		<>
			<Divider />
			<Stack direction="column" spacing="24px">
				<Typography variant="h2">
					{<FormattedMessage id="personalInfo.partageConnexion.title" />}
				</Typography>
				<Stack direction="column" spacing="14px" pl="24px" pr="12px">
					{renderAccess()}
				</Stack>
			</Stack>
			<CreateConjointAccessPopin openForm={openCreateAccess} setOpenForm={setOpenCreateAccess} setUserConjointAccess={setUserConjointAccess} conjointEmail={conjoint ? conjoint[1].email : ""}/>
			<ConfirmCancelInvitePopin open={openCancelInvitAccess} setOpen={setOpenCancelInvitAccess} setUserConjointAccess={setUserConjointAccess}/>
			<ConfirmResendInvitePopin open={openResendAccess} setOpen={setOpenResendAccess} setUserConjointAccess={setUserConjointAccess}/>
			<ConfirmRevokeConjointAccessPopin open={openRevokeAccess} setOpen={setOpenRevokeAccess} setUserConjointAccess={setUserConjointAccess}/>
		</>
	)
}

const actions = {
	getArticleByShortcut: cardiboxActions.articles.getByShortcut
}

const mapStateToProps = (state: any) => ({
	articleNoAccess: cardiboxSelectors.articles.getByShortcut(state.cardibox).partage_acces_intro_acces_inexistant,
	articleSend: cardiboxSelectors.articles.getByShortcut(state.cardibox).partage_acces_intro_acces_envoye,
	articleGranted: cardiboxSelectors.articles.getByShortcut(state.cardibox).partage_acces_intro_acces_actif,
	articleRevoked: cardiboxSelectors.articles.getByShortcut(state.cardibox).partage_acces_intro_acces_revoque
})

export default connect(
	mapStateToProps, actions
)(PartageConnexion)
